import { render, staticRenderFns } from "./ListaAfastamentos.vue?vue&type=template&id=08784254&"
import script from "./ListaAfastamentos.vue?vue&type=script&lang=js&"
export * from "./ListaAfastamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports